import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { QRCode } from 'react-qrcode-logo';

export const DEFAULT_CODE_SIZE = 300;
const QUITE_ZONE = 10;

interface Props {
    size?: number;
    token?: string;
    caption?: string[];
}

export function StudentBadge({ size, token, caption }: Props) {
    return (
        <div style={{ width: '100%', display: 'block', breakInside: 'avoid' }}>
            <Stack gap={1}>
                {token ? (
                    <QRCode size={size ? size - QUITE_ZONE * 2 : DEFAULT_CODE_SIZE - QUITE_ZONE * 2} quietZone={QUITE_ZONE} value={token} />
                ) : (
                    <Skeleton variant='rectangular' sx={{ aspectRatio: 1, width: size ?? DEFAULT_CODE_SIZE, height: 'auto' }} />
                )}

                {caption ? (
                    <Box sx={{ textAlign: 'center' }}>
                        {caption.map((line, index) => (
                            <Typography key={index}>{line}</Typography>
                        ))}
                    </Box>
                ) : (
                    <Stack width='100%' sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Skeleton width='80%' />
                        <Skeleton width='40%' />
                    </Stack>
                )}
            </Stack>
        </div>
    );
}
